const firebaseConfig = {
    apiKey: "AIzaSyCOsodcAISP37lAbpqvdC3yJx_C1pdEYxE",
    authDomain: "auto-pro-luxurious-car.firebaseapp.com",
    projectId: "auto-pro-luxurious-car",
    storageBucket: "auto-pro-luxurious-car.appspot.com",
    messagingSenderId: "846177774983",
    appId: "1:846177774983:web:a8f11aec2b7a8da53f3722"
};
export default firebaseConfig;